import { render, staticRenderFns } from "./cityAuthExchange.vue?vue&type=template&id=35a99c90"
import script from "./cityAuthExchange.vue?vue&type=script&lang=js"
export * from "./cityAuthExchange.vue?vue&type=script&lang=js"
import style0 from "./cityAuthExchange.vue?vue&type=style&index=0&id=35a99c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports